import { DataTableColumnDef } from "@/components/molecules";
import { BlockedDriversTableData } from "./types";

export const blockedDriversColumns: DataTableColumnDef<BlockedDriversTableData>[] = [
  {
    accessorKey: "driverId",
    header: "Driver ID",
    id: "driverId",
    cell: (props) => props.row.original.driverId,
    size: 180,
  },
  {
    accessorKey: "driverName",
    header: "Driver Name",
    id: "driverName",
    cell: (props) => props.row.original.driverName,
    size: 300,
  },
  {
    accessorKey: "reason",
    header: "Reasons",
    id: "reason",
    cell: (props) => props.row.original.reason,
    size: 350,
  },
  {
    accessorKey: "action",
    header: "Action",
    id: "action",
    cell: (props) => props.row.original.action,
    size: 75,
    enableSorting: false,
  },
];
